import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { HpmsTextHtmlAPI } from '@philips-emr/hpms-stipulator-components';
import { PanelAPI, Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnClick, OnClose, OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

import './privacidade.css';

interface TermoUso {
  ieVencido: StatusVencimento;
  dsTermo: string;
}

interface Aviso {
  ieVencido: StatusVencimento;
  dsTermo: string;
}

enum StatusVencimento {
  N = 'N',
  S = 'S',
}

@Controller({ fragment: 'privacidade' })
export default class PrivacidadeController extends BaseController {

  @Inject('panel-termo')
  private panelTermo: PanelAPI;

  @Inject('panel-aviso')
  private panelAviso: PanelAPI;

  @Inject('panel-modal-descricao')
  private panelModal: PanelAPI;

  @Inject('panel-aviso-texto')
  private panelAvisoTexto: PanelAPI;

  @Inject('panel-termo-texto')
  private panelTermoTexto: PanelAPI;

  @Inject('hpms-text-html-aviso')
  private hpmsTextAviso: HpmsTextHtmlAPI;

  @Inject('hpms-text-html-termo')
  private hpmsTextTermoUso: HpmsTextHtmlAPI;

  @OnDynamicContentRender({ target: 'hpms-dynamic-content-field' })
  onDynamicContentRenderAviso(event: RenderEvent): void {
    const { data, render } = event;
    const { ieVencido } = data as Aviso;
    if (ieVencido) {
      render((): ReactElement => <Stamp icon={this.getIconByVencido(ieVencido)} color={this.getColorByVencido(ieVencido)} label={this.getLabelByVencido(ieVencido)} />);
    }
  }

  @OnDynamicContentRender({ target: 'hpms-dynamic-content-field-termo' })
  onDynamicContentRenderTermoUso(event: RenderEvent): void {
    const { data, render } = event;
    const { ieVencido } = data as TermoUso;
    if (ieVencido) {
      render((): ReactElement => <Stamp icon={this.getIconByVencido(ieVencido)} color={this.getColorByVencido(ieVencido)} label={this.getLabelByVencido(ieVencido)} />);
    }
  }

  @OnAfterFetch({ target: 'fetch-aviso' })
  onAfterFetchAviso(event: FetchEvent): void {

    if (event.error || !event.data) {
      this.panelAviso.setVisible(false);
    }
    else if (event.data) {
      const data = event.data as Aviso;
      const { dsTermo } = data;
      const descricaoAviso = dsTermo;
      this.context.set({ descricaoAviso });
    }
  }

  @OnAfterFetch({ target: 'fetch-termo' })
  onAfterFetchTermo(event: FetchEvent): void {
    if (event.error || !event.data) {
      this.panelTermo.setVisible(false);
    }
    else if (event.data) {
      const data = event.data as TermoUso;
      const { dsTermo } = data;
      const descricaoTermoUso = dsTermo;
      this.context.set({ descricaoTermoUso });
    }
  }

  @OnClick({ target: 'card-aviso' })
  onClickCardAviso(): void {
    this.panelModal.setVisible(true);
    this.context.set({ isAviso: true });
  }

  @OnClick({ target: 'card-termo' })
  onClickCardTermo(): void {
    this.panelModal.setVisible(true);
    this.context.set({ isTermo: true });
  }

  @OnMount({ target: 'modal-descricao' })
  onMountModal(): void {
    const isAviso = this.context.get('isAviso') as boolean;
    const isTermo = this.context.get('isTermo') as boolean;
    if (isAviso) {
      this.panelAvisoTexto.setVisible(true);
    }
    if (isTermo) {
      this.panelTermoTexto.setVisible(true);
    }
  }

  @OnMount({ target: 'field-aviso-texto' })
  onMountAvisoTexto(): void {
    const descricaoAviso = this.context.get('descricaoAviso') as string;
    this.hpmsTextAviso.setValue(descricaoAviso);
  }

  @OnMount({ target: 'field-termo-texto' })
  onMountTermoTexto(): void {
    const descricaoTermoUso = this.context.get('descricaoTermoUso') as string;
    this.hpmsTextTermoUso.setValue(descricaoTermoUso);
  }

  @OnClose({ target: 'modal-descricao' })
  onCloseModal(): void {
    this.panelModal.setVisible(false);
    this.context.set({ isAviso: false });
    this.context.set({ isTermo: false });
  }

  private getIconByVencido(ieVencido: StatusVencimento): StampIcon {
    const icon = {
      [StatusVencimento.N]: StampIcon.CHECK,
      [StatusVencimento.S]: StampIcon.CANCELED,
    };

    return icon[ieVencido];
  }

  private getColorByVencido(ieVencido: StatusVencimento): Color {
    const color = {
      [StatusVencimento.N]: Color.SAFETY_GREEN,
      [StatusVencimento.S]: Color.SAFETY_RED,
    };

    return color[ieVencido];
  }

  private getLabelByVencido(ieVencido: StatusVencimento): string {
    if (ieVencido == StatusVencimento.N) {
      return 'Em vigencia';
    }
    return 'Vencido';
  }
}
